import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import ModalExcludeInclude from './ModalExcludeInclude';
import ListExcludeInclude from './ListExcludeInclude';
import ListExcludeIncludeActions from './ListExcludeIncludeActions';
import Spinner from 'react-bootstrap/Spinner';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';

const CriterialExcludeInclude = ({ location }) => {
    const history = useHistory();
    let feasibility = location.state;

    let visitsMod = [];

    const [openModalIncludeExclude, setOpenModalIncludeExclude] = useState(false);
    const [visits, setVisits] = useState([]);
    const [includesExcludes, setIncludesExcludes] = useState([]);
    const [isLoading, setIsLoading] = React.useState(false);

    useEffect(() => {
        configExcInc()
    }, []);

    const regresar = () => {
        let _url = process.env.PUBLIC_URL + "/clinical-studio/dashboard";
        history.push({
            pathname: _url,
            state: feasibility
        });
    }

    const openModalExcludeInclude = () => {
        setOpenModalIncludeExclude(true);
    }

    const closeModalExcludeInclude = () => {
        setOpenModalIncludeExclude(false)
    }

    const configExcInc = () => {
        setIsLoading(true);
        listVisits(feasibility.id_factibilidad);
        listIncludesExclude(feasibility.id_estudio);
        setIsLoading(false);
    }

    const listVisits = async (id_factibilidad) => {
        fetch(`${process.env.REACT_APP_PUBLIC_URL}visitas/consultar`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id_factibilidad: id_factibilidad })
        }).then(response => response.json()).then(data => {
            setVisits(data.contenido);
            visitsMod = data.contenido;
            return data.contenido;
        }).catch(err => {
            console.log(err);
            setVisits([]);
            setIsLoading(false);
        });
    }

    const listIncludesExclude = async (id_estudio) => {
        fetch(`${process.env.REACT_APP_PUBLIC_URL}criteriose/listar`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id_estudio: id_estudio })
        }).then(response => response.json()).then(data => {
            if (data.contenido != undefined) {
                let incex = [];
                for (let i = 0; i < data.contenido.length; i++) {
                    data.contenido[i].feasibility = location.state;
                    data.contenido[i].visitas_all = visitsMod;
                    incex.push(data.contenido[i]);
                }

                setIncludesExcludes(incex);
            }
            else {
                setIncludesExcludes([]);
            }
        }).catch(err => {
            setIsLoading(false);
            setIncludesExcludes([]);
        });
    }

    const ListIncEx = () => {
        return (
            <ListExcludeInclude reactTableData={includesExcludes} ReactTableActions={ListExcludeIncludeActions} />
        );
    }

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Criterios de Inclusión y Exclusión</h3>
                    <h3 className="page-title center-title subhead">{feasibility.nombre_tercero} ({feasibility.acronimo})</h3>

                    <Col md={2}>
                    <div className='top_info_buttons_hc'>
                        <div>
                            <Tooltip
                                title="Regresar al Dashboard"
                            >
                                <IconButton
                                    aria-label="upload picture"
                                    component="span"
                                    className='tooltip-top'
                                    onClick={() => {
                                        regresar();
                                    }}
                                >
                                    <ArrowBackIcon style={{ color: '#153365' }} />
                                </IconButton>
                            </Tooltip>
                            <span style={{ marginLeft: '0.25em' }}>Regresar al Dashboard</span>
                        </div>
                    </div>
                </Col>

                </Col>
            </Row>
            <Card>
                <CardBody>
                    <div className="text-center">
                        <Button onClick={openModalExcludeInclude} className="btn btn-primary btn-sm text-white">
                            Agregar
                        </Button>
                    </div>
                    <Row>

                        {isLoading &&

                            <div className="text-center">
                                <Spinner animation="border" variant="success" />
                            </div>

                        }

                        <ListIncEx />
                    </Row>
                </CardBody>
            </Card>
            <ModalExcludeInclude
                feasibility={location.state}
                closeIncludeExcludeModal={closeModalExcludeInclude}
                opened={openModalIncludeExclude}
                visits={visits}
                listIncludesExclude={configExcInc}
            />
        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_criterial_excinc', // a unique identifier for this form
})(CriterialExcludeInclude);